<template>
  <div class="box">
    <div class="one">
      <div class="line" v-if="!last"></div>
      <div :class="lineClass" @click="stepClick(stepData.url)">
        {{stepData.current +1 }}
      </div>
    </div>
    <div class="sc">{{stepData.title}}</div>
  </div>
</template>

<script>
  export default {
    name: 'stepItem',
    data() {
      return {

      }
    },
    props: {
      stepData: {
        type: Object,
      },
      last: {
        type: Boolean
      }
    },
    computed:{
      numClass() {
        let str = `item-num position-parent ${this.last ? '' : 'ttt step-success'}`;
        this.stepData.url == this.$route.path ? str += ' active' : str;
        return str
      },
      lineClass() {
        return `cycle ${this.stepData.url == this.$route.path ? 'active' : ''}`;
      }
    },
    mounted() {
      // console.log(this.$route.name)
    },
    methods:{
      stepClick(url) {
        this.$router.push({
            path: url,
        });
      }
    }

  }
</script>

<style lang='less' scoped>
.box {
  flex: 1;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  flex-flow: column;

  .one {
    position: relative;
    display: flex;
    flex: 1;
    flex-grow: 1;

    .line {
      position: absolute;
      height: 2px;
      left: 0;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      background-color: black;
      background-color: #fff;
    }

    .cycle {
      width: 38px;
      height: 38px;
      border-radius: 50%;
      line-height: 38px;
      text-align: center;
      color: #EFAF58;
      background: #FDF4E6;
      border: 2px solid #2f3542;
      position: relative;
      z-index: 0;
    }

    .active{
      width: 38px;
      height: 38px;
      line-height: 38px;
      text-align: center;
      background: #fff;
    }
  }
  .sc {
    font-size: 12px;
    margin-top: 2px;
  }
}
  .item-wrap{
    // width: 100%;
    flex: 1;
    flex-grow: 1;
    margin-top: 15px;
    // max-width: 76px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    position: relative;
    .item-num{
      width: 2rem;
      height: 2rem;
      line-height: 2rem;
      border-radius: 50%;
      text-align: center;
      color: #EFAF58;
      background: #FDF4E6;
      border: 2px solid #C0C4CC;
    }
    .step-success::after {
      background-color: #C0C4CC;
    }
    .active{
      width: 2rem;
      height: 2rem;
      line-height: 2rem;
      text-align: center;
      background: #fff;
    }
    .item-content{
      font-size: 14px;
      color: #FEFCF8;
      font-weight: 400;
      color: #FFFFFF;
      height: 14px;
    }
  }
  .position-parent{
    position: relative;
  }
  .position-child {
    position: absolute;
    
    top: 50%;
    transform: translateY(-50%);
    img{
      display: inline-block;
      width: 38px;
      height: 6px;
    }
  }
.ta:after {
  content: '';
  position: absolute;
  top: 50%;
  // right: -20px; /* 调整实线位置 */
  left: 50%;
  transform: translateY(-50%);
  // width: 20px; /* 调整实线长度 */
  width: 100%;
  height: 2px; /* 调整实线粗细 */
  background-color: black; /* 调整实线颜色 */
}
  
</style>
